import type { FC } from 'react'

import { Controller } from 'react-hook-form'

import { TextField } from '@/components/ui/text-field'
import { FormItem } from '@/modules/shifts/ui/create-edit-form/form-item'

import { MemberSelection } from './member-selection'

interface Props {
  isDisabled?: boolean
}

export const TeamRoleForm: FC<Props> = ({ isDisabled }) => {
  return (
    <div className="mb-8 flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <FormItem label="Role Name">
          <div className="relative">
            <Controller
              disabled={isDisabled}
              name="name"
              render={({ field, fieldState }) => (
                <div>
                  <TextField
                    {...field}
                    onChange={field.onChange}
                    placeholder="Role Name"
                    id="name"
                    disabled={isDisabled}
                  />
                  {fieldState.error?.message && (
                    <span className="text-sm text-danger-default ">
                      {fieldState.error?.message}
                    </span>
                  )}
                </div>
              )}
            />
          </div>
        </FormItem>
      </div>
      <Controller
        name="memberIds"
        render={({ field }) => (
          <MemberSelection
            selectedMemberIds={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  )
}
